import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card } from "@mui/material";
import { endpoints } from "../../services/apiurl";
import Input from "../UI/Input/Input";
import PageTitle from "../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import FileUploader from "../FileUploader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const EditOutlet = () => {
  let history = useHistory();
  let { id } = useParams();

  const [outlet, setOutlet] = useState({
    outlet_name: "",
    restro_id: "",
    image: "",
    airmenu_id: "",
    position: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileSelectSuccess = (file) => {
    setSelectedFile(file);
  };

  const handleFileSelectError = ({ error }) => {
    alert(error);
  };
  const [loading, setloading] = useState(false);
  const [rest, setRest] = useState([]);

  const { outlet_name, restro_id, image, airmenu_id, position } = outlet;
  const onInputChange = (e) => {
    setOutlet({ ...outlet, [e.target.name]: e.target.value });
    //console.log(outlet);
  };

  useEffect(() => {
    editoutlets();
    getRestaurentsDropDown();
  }, []);

  const getRestaurentsDropDown = async () => {
    await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
      setRest(response.data.data);
    });
  };

  const editoutlets = async () => {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    let airmenu_id = b.airmenu_id;
    let position = b.position;

    await axios
      .post(endpoints.editOutlet, {
        id: id,
        user_id: user_id,
        restro_id: restro_id,
        airmenu_id: airmenu_id,
        position: position,
      })
      .then((response) => {
        setOutlet({
          id: response.data.data.id,
          outlet_name: response.data.data.outlet_name,
          restro_id: response.data.data.restro_id,
          image: response.data.data.image,
          airmenu_id: response.data.data.airmenu_id,
          position: response.data.data.position,
        });
      });
  };

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();
    // if (media_type == 1) {
    //     if (!selectedFile) {
    //         alert('Please select image');
    //         return false;
    //     }
    // }

    const formData = new FormData();

    formData.append("restro_id", restro_id);
    formData.append("outlet_name", outlet_name);
    formData.append("airmenu_id", airmenu_id);
    formData.append("position", position);
    formData.append("id", id);

    formData.append("image", selectedFile);

    try {
      const response = await axios.post(endpoints.updateOutlet, formData);
      setloading(false);
      history.goBack();
      if (response.data && response.data.status === true) {
        toast.success("Outlet Updated Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        // Handle other cases if needed
      }
    } catch (error) {
      console.error("Error during Updated Outlet:", error);
      setloading(false);

      toast.error("Error during Updated Outlet. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const removeImageHandler = async (id, type) => {
    await axios
      .post(endpoints.deleteImageOutlet, { id, type })
      .then((response) => {});
    window.location.reload();
  };

  return (
    <div className="ui main">
      <PageTitle title="Edit Outlet" linkurl="" linkTitle="" />
      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <div className="col col-6">
              <label>Main Restaurents </label>
              <select
                name="airmenu_id"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={airmenu_id}
              >
                <option value="">Select Restaurents</option>
                {rest.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col col-6">
              <Input
                id="outlet_name"
                label="Name"
                type="text"
                name="outlet_name"
                place="Name"
                onChange={(e) => onInputChange(e)}
                requiredInput="true"
                value={outlet_name}
              />
            </div>
          </div>
          <div className="row">
            <div className="col col-3">
              <label>Outlet Restaurents</label>
              <select
                name="restro_id"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={restro_id}
              >
                <option value="">Select Restaurents</option>
                {rest.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <Input
              id="position"
              label="Position No."
              type="text"
              name="position"
              place="Position No."
              onChange={(e) => onInputChange(e)}
              value={position}
              class="col col-2"
            />
            <div className="col col-6">
              <label>Image</label>
              {image !==
              "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <img
                    src={image}
                    height="200px"
                    width="200px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "image")}
                  >
                    {/* Delete */}
                  </Button>
                </div>
              ) : (
                <div className="mt-3">
                  <FileUploader
                    onFileSelectSuccess={handleFileSelectSuccess}
                    onFileSelectError={handleFileSelectError}
                  />
                  {selectedFile && (
                    <div>
                      <p>Preview:</p>
                      <img
                        src={URL.createObjectURL(selectedFile)}
                        alt="Selected Logo"
                        height="200px"
                        width="200px"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default EditOutlet;
